import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Highball.svg",
  "use": "Highball.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Highball.svg\"><path d=\"M44.2326,54.1673A2,2,0,0,1,42.2384,56H21.75a2,2,0,0,1-1.9943-1.8327L15.9926,9.0837A1,1,0,0,1,16.99,8h30.008a1.0005,1.0005,0,0,1,.9976,1.0834ZM20.2966,12.5419l.5841,7A.5.5,0,0,0,21.3788,20h21.23a.5.5,0,0,0,.4985-.4584l.5841-7A.5.5,0,0,0,43.1932,12H20.7947A.5.5,0,0,0,20.2966,12.5419Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol